import React from 'react'
import {Box, Text, Flex, Button} from '@chakra-ui/react'
import {Screen, ThemeProvider, LogoHorizontal} from '../../../components'

const DashboardFailureScreen = () => {
  return (
    <ThemeProvider>
      <Screen>
        <Flex justifyContent="center" mt={4}>
          <LogoHorizontal width={250} height={100} />
        </Flex>
        <Box w={{sm: '100%', md: '70%', lg: '50%'}} margin="auto">
          <Box mt={4}>
            <Text
              textStyle="body-intro-medium"
              fontSize="lg"
              mb="sm"
              textAlign="center"
            >
              Contact us for more information
            </Text>
            <Text textAlign="center">
              There was an issue creating your account.
            </Text>
            <Text textAlign="center">
              Please contact our sales team for more information.
            </Text>

            <Flex justifyContent="center" mt={12}>
              <Button
                variant="primary"
                colorScheme="primary"
                as="a"
                px="xl"
                href="mailto:sales@withmarmalade.com"
              >
                Contact us now
              </Button>
            </Flex>
          </Box>
        </Box>
      </Screen>
    </ThemeProvider>
  )
}

export default DashboardFailureScreen
